import defaultState from "./state";

const Reducer = (state = defaultState, action) => {
  switch (action.type) {
    case "LOADING_FERIADOS_SCHEDULER": {
      return Object.assign({}, state, {
        isLoading: action.isLoading,
      });
    }
    case "OPEN_CLOSE_MODAL_EDITAR_SCHEDULER": {
      return Object.assign({}, state, {
        isOpenModalEditarScheduler: action.isOpen,
        appointment: action.appointment,
        isEditAppointment: action.isNew,
      });
    }
    case "OPEN_CLOSE_MODAL_ELIMINAR_APPOINTMENT": {
      return Object.assign({}, state, {
        isOpenModalEliminarAppointment: action.isOpen,
        appointment: action.appointment,
      });
    }
    case "SET_APPOINTMENT": {
      return Object.assign({}, state, {
        appointment: action.data,
      });
    }
    case "SET_APPOINTMENT_LIST": {
      return Object.assign({}, state, {
        listaAppointments: action.list,
      });
    }
    case "SET_APPOINTMENT_CENTROS": {
      return Object.assign({}, state, {
        listaCentros: action.data,
      });
    }
    default:
      return state;
  }
};

export default Reducer;
